import type { KeyboardEvent } from 'react';
import type { ResolvedColumn } from '../../domain';
import { groupColumns } from './utils';

export interface ColumnDropdownProps<T> {
    columns: ResolvedColumn<T>[];
    onSelect: (col: ResolvedColumn<T>) => void;
    onKeyDown: (
        e: KeyboardEvent<HTMLButtonElement>,
        activate: () => void,
    ) => void;
}

export function ColumnDropdown<T>(props: ColumnDropdownProps<T>): JSX.Element {
    const { columns, onSelect, onKeyDown } = props;
    const grouped = groupColumns(columns);
    return (
        <div className="ics-table__search-dropdown" role="listbox">
            {Object.entries(grouped).map(([groupHeader, cols]) => (
                <div key={groupHeader || '_root'}>
                    {groupHeader ? (
                        <div className="ics-table__search-dropdown-group">
                            {groupHeader}
                        </div>
                    ) : null}
                    {cols.map((col) => (
                        <button
                            key={col.id}
                            type="button"
                            role="option"
                            aria-selected={false}
                            className="ics-table__search-dropdown-item"
                            onClick={() => {
                                onSelect(col);
                            }}
                            onKeyDown={(e) => {
                                onKeyDown(e, () => {
                                    onSelect(col);
                                });
                            }}
                        >
                            {col.header}
                        </button>
                    ))}
                </div>
            ))}
        </div>
    );
}
